import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Tooltip } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';

import { useTrans } from "~/hooks/useTrans";
import { sortProjects } from "~/utils/utils";
import { IClientProject } from "~/providers/client-interfaces";

interface IArchivedProjectsTable {
	items: Array<IClientProject>;
	onRecoverProject?: (project: IClientProject) => void;
}

export default function ArchivedProjectsTable({
	items = [],
	onRecoverProject = () => {},
}: IArchivedProjectsTable) {
	const { trans } = useTrans();
	const HEADERS: Array<{
		trans: string;
		center?: boolean;
	}> = [
		{ trans: "projectSettingsPage.idProject" },
		{ trans: "projectSettingsPage.nameProject" },
		{ trans: "projectSettingsPage.desc" },
		{ trans: "allProjectsPage.projectState", center: true },
		{ trans: "" },
	];

	return <TableContainer component={Paper}>
		<Table sx={{ minWidth: 650 }} aria-label="table">
			<TableHead>
				<TableRow>
					{ HEADERS.map(header => <TableCell sx={{ fontWeight: "bold", ...header.center ? { textAlign: "center" } : {} }} key={header.trans}>
						{ header.trans && trans(header.trans) }
					</TableCell>) }
				</TableRow>
			</TableHead>
			<TableBody>
				{ sortProjects(items).map(project => (<TableRow key={project.id}>
					<TableCell>
						{ project.internalName }
					</TableCell>
					<TableCell>
						{ project.userTitle || trans("empty") }
					</TableCell>
					<TableCell>
						{ project.userDescription || trans("empty") }
					</TableCell>
					<TableCell className="text-align-center">
						{ project.canConsume
							? <span style={{ color: "var(--dark-green-text-color)" }}>
								{ trans("allProjectsPage.projectStateActive") }
							</span>
							: <span style={{ color: "var(--red-text-color)", position: "relative" }}>
								{ trans("allProjectsPage.projectStateInactive") }
								<Tooltip title={project.forbiddenConsumptionReason} sx={{ position: "absolute", top: "-3px", marginLeft: "5px", cursor: "pointer" }}>
									<InfoIcon />
								</Tooltip>
							</span> }
					</TableCell>
					<TableCell sx={{ textAlign: "right" }}>
						<Button variant="outlined" color="success" onClick={() => onRecoverProject(project)}>
							{ trans("projectsPage.recoverProject") }
						</Button>
					</TableCell>
				</TableRow>)) }
			</TableBody>
		</Table>
	</TableContainer>;
}
